module.exports = __webpack_public_path__ + "components/weather-icon/static/daylightsnow@3-ac68275692e13c66cd01c02ee3cc0a29.png";